// removed by extract-text-webpack-plugin
module.exports = {"loved":"_2nUN5"};


//////////////////
// WEBPACK FOOTER
// ./components/item/loveButton/loveButton.scss
// module id = 268
// module chunks = 0